import { type RefObject, memo } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import RenderPage from "../../functionalComponents/RenderPage";
import { RenderedPageElementsToDisplay } from "../../state/page";
import DisplayElementsChildren from "./DisplayElementsChildren";

const PageWrapper = styled.div`
	width: 100%;
	overflow: hidden;
	position: relative;
	display: grid;
	grid-template-rows:auto;
	justify-content: center; /* Horizontally center the content */
	align-items: center; /* Vertically center the content */
	min-height: 100%; 
`;

const ScrollPageWrapper = memo(
	({
		pageIndex,
		scrollerRef,
	}: { pageIndex: number; scrollerRef: RefObject<HTMLDivElement> }) => {
		// RenderPage will calculate and store the elements for this pageIndex
		RenderPage({ index: pageIndex });

		const pageElementsToDisplay = useRecoilValue(
			RenderedPageElementsToDisplay(pageIndex),
		);

		return (
			<PageWrapper id={`scroll-page-${pageIndex}`}>
				<DisplayElementsChildren
					pageElementsToDisplay={pageElementsToDisplay}
					pageIndex={pageIndex}
					key={`scroll-page-children-${pageIndex}`}
					scrollerRef={scrollerRef}
				/>
			</PageWrapper>
		);
	},
);

export default ScrollPageWrapper;
